import request from '@/utils/request';
import {
  urlAPI,
} from '@/api/constAPI';

export function login(data) {
  return request({
    url: '/connect/token',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

// export function getOAuthAccessToken() {
//   return request({
//     url: '/leads.portal/auth/token',
//     method: 'get',
//   });
// }

export function getOAuthAccessToken() {
  let baseURL = 'https://qa.vorwerk.com.cn';
  // let baseURL = 'http://qaadmin.vorwerkchina.com';
  if (process.env.NODE_ENV === 'development'
    || process.env.NODE_ENV === 'hotfix') {
    baseURL = 'https://qa.vorwerk.com.cn';
    // baseURL = 'http://qaadmin.vorwerkchina.com';
  }
  if (process.env.NODE_ENV === 'staging') {
    baseURL = 'https://qaadmin.vorwerkchina.com';
  }
  if (process.env.NODE_ENV === 'preproduction') {
    baseURL = 'https://preadmin.vorwerkchina.com';
  }
  if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://admin.vorwerkchina.com';
  }
  const url = urlAPI.oAuthAccessToken;
  return request({
    url,
    method: 'get',
    baseURL,
  });
}

export function logout() {
  return request({
    url: '/api/account/logout',
  });
}

export function getOauthUserInfo() {
  return request({
    url: '/oauth/connect/userinfo',
    method: 'get',
  });
}

export function getInfo() {
  return request({
    url: '/api/app/book/user',
    method: 'get',
  });
}

export function getUser(id) {
  return request({
    url: `/api/identity/users/${id}`,
    method: 'get',
  });
}


export function getUserRoles(id) {
  return request({
    url: `/api/identity/users/${id}/roles`,
    method: 'get',
  });
}

export function addUser(data) {
  return request({
    url: '/api/identity/users',
    method: 'post',
    data,
  });
}

export function editUser(data) {
  return request({
    url: `/api/identity/users/${data.id}`,
    method: 'put',
    data,
  });
}

export function deleteUser(id) {
  return request({
    url: `/api/identity/users/${id}`,
    method: 'delete',
  });
}

export function getUserList(query) {
  const {
    skipCount,
    pageSize,
  } = query;
  const url = `/api/identity/users?SkipCount=${skipCount}&MaxResultCount=${pageSize}`;
  return request({
    url,
    method: 'get',
  });
}


export function getUserPermission(userId) {
  return request({
    url: `/api/permission-management/permissions?providerName=U&providerKey=${userId}`,
    method: 'get',
  });
}


export function addUserPermission(userId, data) {
  return request({
    url: `/api/permission-management/permissions?providerName=U&providerKey=${userId}`,
    method: 'put',
    data,
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js